module.exports = __webpack_public_path__ + "img/gb6560.prt.9b15db7a.jpg";